import React from 'react'
import { v7 as uuidv7 } from 'uuid'

import { useSatuEventTracker } from 'utils/satuEvent'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { getOrCreateSessionId } from 'utils/satu-event-tracker/core/utils'
import { useAuth } from 'utils/auth'
import { convertToKeyValuePairs } from 'utils/object'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'
import { getDeviceId } from 'utils/deviceId'
import { useKinerjaHarianRole } from 'app/KinerjaHarian/hooks/useKinerjaHarianRole'

import type { KinerjaHarianRole } from 'types/kinerja-harian'
import type { KinerjaTipe } from 'types/kinerja'

const TABLE_NAME: string = 'kinerja_harian_fe_user_action_v1'
const DEFAULT_TIMEOUT: number = 5_000 // 5 seconds

const ROLE_ACTOR_LABEL: Record<KinerjaHarianRole, string> = {
  GURU: 'guru',
  KS: 'kepala sekolah',
  PS: 'pengawas sekolah',
}

const TIPE_ACTOR_LABEL: Partial<Record<KinerjaTipe, string>> = {
  GPK: 'gpk',
}

type TrackEventProps = {
  activityType: string
  screenName: string
  additionalParams?: Record<string, any>
}

export const useKinerjaHarianTrackEvent = () => {
  const { SETrackEvent } = useSatuEventTracker()
  const { periodYear } = usePeriodContext()
  const { session } = useAuth()
  const { role } = useKinerjaHarianRole()
  const { tipe } = useKinerjaTipe()

  const actor = React.useMemo(() => {
    if (['GPK'].includes(tipe)) {
      return TIPE_ACTOR_LABEL[tipe]
    }
    return role ? ROLE_ACTOR_LABEL[role] : undefined
  }, [role, tipe])

  const trackEvent = React.useCallback(
    ({
      activityType,
      screenName,
      additionalParams = {},
    }: TrackEventProps): void => {
      SETrackEvent({
        eventName: TABLE_NAME,
        eventParams: {
          activity_type: activityType,
          screen_name: screenName,
          actor,
          year: periodYear.toString(),
          session_id: getOrCreateSessionId(() => uuidv7()),
          user_agent: navigator?.userAgent || '',
          user_id: session?.user?.id || '',
          device_id: getDeviceId() || '',
          attributes: convertToKeyValuePairs({
            email: session?.user?.email,
            ptk_id: session?.user?.ptkId,
            ...additionalParams,
          }),
        },
        timeout: DEFAULT_TIMEOUT,
        keepAlive: true,
        sendAttributes: false,
      })
    },
    [SETrackEvent, periodYear, session, actor]
  )

  return {
    trackEvent,
  }
}
